export const GOOGLE_MAPS_KEY = 'AIzaSyB20nULHf3dCpq5ye8kePpncnyayadq_80'

export function parseCoordinates(coordinates) {
    if (!coordinates) {
        return null
    }
    const [lat, lng] = String(coordinates).split(',').map(value => Number(value.trim()))
    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null
}

export function getStaticMapUrl({ lat, lng }, { width = 640, height = 320, zoom = 16 } = {}) {
    const position = `${lat},${lng}`
    const params = [
        `center=${position}`,
        `zoom=${zoom}`,
        `size=${width}x${height}`,
        'scale=2',
        `markers=${encodeURIComponent(`color:0xff7133|${position}`)}`,
        `key=${GOOGLE_MAPS_KEY}`
    ]
    return `https://maps.googleapis.com/maps/api/staticmap?${params.join('&')}`
}
